// Inline Bokun booking button. Renders a `.bokunButton` element with a `data-src`
// so the Bokun widgets loader opens the booking modal ON the page (instead of a new
// tab). The loader is injected once and watches the DOM for these buttons, so it also
// binds buttons that mount after client-side navigation.
import React, { useEffect } from 'react';
import { bokunDataSrc, BOKUN_LOADER_SRC } from '../constants/booking';

const LOADER_ID = 'bokun-widgets-loader';

const ensureBokunLoader = () => {
    if (typeof document === 'undefined' || document.getElementById(LOADER_ID)) return;
    const script = document.createElement('script');
    script.id = LOADER_ID;
    script.async = true;
    script.src = BOKUN_LOADER_SRC;
    document.body.appendChild(script);
};

interface BokunBookButtonProps {
    experienceId: string;
    className?: string;
    children?: React.ReactNode;
}

// Forwards `className` so it can be wrapped with styled() and still keep the
// `bokunButton` class the loader looks for.
const BokunBookButton: React.FC<BokunBookButtonProps> = ({ experienceId, className, children }) => {
    useEffect(() => {
        ensureBokunLoader();
    }, []);

    return (
        <button
            type="button"
            className={['bokunButton', className].filter(Boolean).join(' ')}
            data-src={bokunDataSrc(experienceId)}
            data-testid="widget-book-button"
        >
            {children ?? 'Book Now'}
        </button>
    );
};

export default BokunBookButton;
